import isNil from 'lodash/isNil'
import isEmpty from 'lodash/isEmpty'

export const key = 'guide'

function setGuideLine(chart, item) {
  const { type, ...newItem } = item
  chart.guide().line(newItem)
}

function setGuideTag(chart, item) {
  const { type, ...newItem } = item
  chart.guide().tag({ ...newItem })
}

function setGuideArc(chart, item) {
  const { quickType } = item
  if (quickType === 'parallel') {
    const { data } = item
    chart.guide().arc({
      start: ['min', data],
      end: ['max', data],
      ...item,
    })
    chart.guide().arc({
      start: ['max', data],
      end: ['min', data],
      ...item,
    })
  } else if (quickType === 'normal') {
    const { data } = item
    chart.guide().line({
      start: [data, 'min'],
      end: [data, 'max'],
      ...item,
    })
  } else {
    const { type, ...newItem } = item
    chart.guide().arc(newItem)
  }
}

function setGuideText(chart, item) {
  const { type, ...newItem } = item
  chart.guide().text(newItem)
}

function setGuideHtml(chart, item) {
  const { type, ...newItem } = item
  chart.guide().html(newItem)
}

function setGuideRect(chart, item) {
  const { type, ...newItem } = item
  chart.guide().rect(newItem)
}

export const process = (chart, config) => {
  const isArr = Array.isArray(config)

  if (isNil(config) || isEmpty(config)) {
    return
  }

  const arrGuide = isArr ? config : [config]

  // 清空 guides
  chart.guide().clear()

  arrGuide.forEach((res) => {
    if (res.type === 'line') {
      setGuideLine(chart, res)
    } else if (res.type === 'text') {
      setGuideText(chart, res)
    } else if (res.type === 'tag') {
      setGuideTag(chart, res)
    } else if (res.type === 'rect') {
      setGuideRect(chart, res)
    } else if (res.type === 'arc') {
      setGuideArc(chart, res)
    } else if (res.type === 'html') {
      setGuideHtml(chart, res)
    }
  })
}
